import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Box, IconButton, Tooltip } from '@mui/material';

import type { OnboardingStepResourceLink } from '../types';

type OnboardingStepResourceLinksProps = {
  links: OnboardingStepResourceLink[];
};

function getResourceLinkTooltipTitle(link: OnboardingStepResourceLink): string {
  if (link.guidance?.trim()) {
    return `${link.label}: ${link.guidance.trim()}`;
  }

  return link.label;
}

export function OnboardingStepResourceLinks({
  links,
}: OnboardingStepResourceLinksProps) {
  if (!links.length) {
    return null;
  }

  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, flexShrink: 0 }}>
      {links.map((link) => (
        <Tooltip
          key={link.id}
          title={getResourceLinkTooltipTitle(link)}
          arrow
          placement="top"
          slotProps={{
            tooltip: {
              sx: { maxWidth: 320 },
            },
          }}
        >
          <IconButton
            component="a"
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            size="small"
            aria-label={link.label}
            sx={{
              width: 28,
              height: 28,
              color: 'primary.main',
            }}
          >
            <OpenInNewIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
}
